import React from 'react';

import HeroPowerMeter from '../../../main/assets/images/powerMeterV2/power-meter-hero-section.webp';
import HeroBg from '../../../main/assets/images/powerMeterV2/Hero-red-effect.webp';

export const Hero = () => {
  return (
    <div className="power-meter-hero">
      <div className="power-meter-hero-text-container">
        <div className="power-meter-hero-text-subcontainer">
          <div className="power-meter-hero-subtitle">RF Power Meter v2</div>
          <div className="power-meter-hero-title">
            Essential
            <br />
            FPV Tool
          </div>
        </div>
        <div className="power-meter-hero-description">
          The Power Meter v2 ensures precise RF control and video link
          performance, now upgraded with an internal battery, attenuator, and
          key enhancements over the original.
        </div>
        <div className="dreamX__discover--button">
          <a
            href="https://shop.orqafpv.com/products/rf-power-meter-v2?_pos=3&_sid=af01b4fc5&_ss=r"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn--primary btn--med"
            onMouseDown={event => event.preventDefault()}
          >
            buy now
          </a>
        </div>
      </div>
      <img
        src={HeroBg}
        className="power-meter-hero-bg"
        alt="Background Image with Red Effect for Landing Section"
      />
      <img
        src={HeroPowerMeter}
        className="power-meter-hero-image"
        alt="RF Power Meter version two Product"
      />
    </div>
  );
};
